import * as OrgRoleActions from 'admin/actions/OrgRoleActions';
import AffiliationShape, { getNeedsEmailConf, needsEmailConf, needsOptIn } from 'shapes/Affiliation';
import AffiliationStatus from 'organizations/components/AffiliationStatus.jsx';
import Button from 'components/Button.jsx';
import DeviceActions from 'actions/DeviceActions';
import OrganizationStore from 'stores/OrganizationStore';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import MailTo from 'components/MailTo.jsx';
import ToastActions from 'actions/ToastActions';
import React from 'react';

import './styles/SchoolAffiliationPending.scss';

const SchoolAffiliationPending = React.createClass({
  propTypes: {
    affiliation: AffiliationShape.isRequired,
    extraSubtext: React.PropTypes.node,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [linkStateWithStores([OrganizationStore])],

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    const org = OrganizationStore.getOrganization(this.props.affiliation.organization_id);
    return {
      orgName: org ? org.getName() : '',
    };
  },

  getMessages(aff) {
    let subtext;
    let title;
    if (needsOptIn(aff)) {
      title = 'Introducing Remind for Schools';
      subtext = (<p>{`Reach your school instantly with direct, reliable messaging.
 Get started and we'll notify the teachers who use Remind that ${this.state.orgName}
 has a verified administrator.`}</p>);
    } else if (needsEmailConf(aff)) {
      title = 'Get the new Remind for Schools';
      subtext = (<p>{`Confirm your email address so we can verify you as an administrator and give
you access to features that support better communication at ${this.state.orgName}.`}</p>);
    } else {
      title = 'We’re verifying your status';
      subtext = (
        <span>
          <p>
            {`Verifying administrators usually takes 1 to 3 business days. You'll get an email as
            soon as we're done!`}
          </p>
          <br />
          <p>
            {`We currently verify principals and assistant principals at US K-12 schools.
            If you’re an administrator in a different role, please send an email to `}
            <MailTo to="schooladmin@remindhq.com" />
            {' and cc your principal for access to school features.'}
          </p>
        </span>
);
    }
    return { title, subtext };
  },

  resendConf() {
    const email = getNeedsEmailConf(this.props.affiliation).official_email;
    DeviceActions.resendConfirmationEmail(email).then(
      () => ToastActions.showSuccessToast('Sent! Please check your email in a few minutes'),
      (error) => ToastActions.showAPIError(error)
    );
  },

  acceptAdminship() {
    const org = OrganizationStore.getOrganization(this.props.affiliation.organization_id);
    OrgRoleActions.adminOptIn(org.id, org.getName(), this.props.affiliation);
    this.context.router.push('/classes');
  },

  rejectAdminship() {
    const org = OrganizationStore.getOrganization(this.props.affiliation.organization_id);
    OrgRoleActions.adminOptOut(org.id, org.getName(), this.props.affiliation);
    this.context.router.push('/classes');
  },

  renderCTA(aff) {
    if (needsOptIn(aff)) {
      return (
        <Button
          className="SchoolAffiliationPending-CTAButton"
          eventElementName="SchoolAffiliationPending-CTAButton"
          onClick={this.acceptAdminship}>
          Get Remind for Schools
        </Button>
      );
    } else if (needsEmailConf(aff)) {
      return (
        <Button
          className="SchoolAffiliationPending-CTAButton"
          eventElementName="SchoolAffiliationPending-CTAButton"
          onClick={this.resendConf}>
          Resend confirmation email
        </Button>
      );
    }
  },

  render() {
    const aff = this.props.affiliation;
    const { title, subtext } = this.getMessages(aff);

    return (
      <div>
        <AffiliationStatus
          className="SchoolAffiliationPending"
          avatarSrc={require('assets/images/school-circle.svg')}
          title={title}
          subtext={subtext}>
          {this.props.extraSubtext}
          {this.renderCTA(aff)}
          {this.props.children}
          {needsOptIn(aff) &&
            <Button
              className="SchoolAffiliationPending-RejectButton"
              eventElementName="SchoolAffiliationPending-RejectButton"
              onClick={this.rejectAdminship}
              level="text">
              Don’t want Remind for Schools?
            </Button>}
        </AffiliationStatus>
      </div>
    );
  },
});

export default SchoolAffiliationPending;



// WEBPACK FOOTER //
// ./src/organizations/components/SchoolAffiliationPending.jsx